import { Typography } from 'antd';
import { default as React } from "react";
import styles from './UntrackableCohortMessage.module.scss';
import { ReactComponent as WarningIcon } from './warning.svg';

const { Paragraph, Title } = Typography;

const UntrackableCohortMessage = () => {
    return <div className={styles.container}>
        <WarningIcon className={styles.icon} />
        <div className={styles.message}>
            <Title>Oops!</Title>
            <Paragraph>
                Your cohort has hit the maximum number of patients permitted for tracking analysis. Please add more filters to your cohort description to lower the patient count.
            </Paragraph>
            <Paragraph>
                Top tip, reduce your timeframe fields to reduce the patient cohort number.
            </Paragraph>
            <Paragraph>
                <span style={{ fontStyle: "italic" }}>*Please contact support if you need the patient count increased. We can be flexible with your cohort maximum for important analysis.</span>
            </Paragraph>
        </div>
    </div>
}

export default UntrackableCohortMessage